<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>公告管理</el-breadcrumb-item>
    <el-breadcrumb-item>公告查询</el-breadcrumb-item>
  </el-breadcrumb>
    <el-card>
    <el-table
    :data="accessoryList"
    border
    style="width: 100%">
    <el-table-column
      prop="fileCode"
      label="任务码"
      show-overflow-tooltip
      width="100">
    </el-table-column>
    <el-table-column
      prop="fileOldName"
      show-overflow-tooltip
      label="附件名称"
      width="130">
    </el-table-column>
    <el-table-column
      width="180"
      prop="fileSize"
      label="文件大小"
      :formatter="setSize">
    </el-table-column>
    <el-table-column
      width="180"
      prop="createDate"
      label="上传时间">
    </el-table-column>
    <el-table-column
      width="180"
      prop="fileSubUser"
      label="上传用户">
    </el-table-column>
    <el-table-column
      label="操作" 
      width="120">
      <template slot-scope="scope">
        <el-button  @click="downFile(scope.row)">下载</el-button>
</template>
    </el-table-column>
  </el-table>
  </el-card>
  </div>
</template>

<script>
export default {
  created(){
        this.getAccessory()
    },
    data(){
      return{
        accessoryList:[],
      }
    },
    methods:{
      getAccessory(){
        this.axios.post("/announcement/selectAccessory")
         .then(resp => { 
                       if(resp.data.status == 1) {
                            this.accessoryList=resp.data.result
                            console.log( this.accessoryList)
                                }else {
                               
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
    },setSize(row, column){
      return row.fileSize+' KB'
    },downFile(data){
      console.log(data)
          const formData = new FormData()
      formData.append('filePath', data.filePath)
      formData.append('oldFileName', data.fileOldName)
          this.axios({
            url: "/announcement/downFile",   //后端地址
            method: "post",
            data:formData, //请求参数
            headers: {  
            'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
            },
            // contenType:'application/json',
            responseType: "blob"
          })
            .then(res => {
              console.log(res.data)
              
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = data.fileOldName; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
      
            })
        
    }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/leader/ViewAccessory.vue